/* keys of the tm_consent cookie, also read by topmeteo/utils/consent.py */
export const VersionKey = 'v';
export const TimestampKey = 't';
export const StatisticKey = 's';
export const MarketingKey = 'm';
